module.exports = __webpack_public_path__ + "media/images/svg/x-0613f10a99073a2f9674a9d5b7673bde.svg";